module.exports = __webpack_public_path__ + "static/img/アセット 12@2x.3013ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 12@2x.png
// module id = l2Gq
// module chunks = 1